var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{},[_c('charge',{ref:"charge",attrs:{"item-count":_vm.itemCount,"csrfToken":_vm.csrfToken,"region-id":_vm.regionId,"return-done-date":_vm.returnDoneDate,"region-currency":_vm.regionCurrency}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }